import { c as _c } from "react/compiler-runtime";
// Per-channel chromatic displacement filter for the lifted lens. Rendered
// OUTSIDE the bar root so a root `overflow:hidden` + `isolation` can't drop the
// backdrop-filter SVG ref. Wide region (300%) so displacement never samples
// outside the backdrop. The three `feDisplacementMap`s (one per RGB channel)
// are driven imperatively by the engine via `getElementById` on the ids below,
// then recombined ADDITIVELY (`feComposite` arithmetic k2=k3=1 → i1+i2) to give
// the chromatic rim.
export function LiquidGlassNavFilter(t0) {
  const $ = _c(22);
  const {
    filterId,
    dispRId,
    dispGId,
    dispBId,
    mapUrl,
    lensW,
    lensH
  } = t0;
  const t1 = mapUrl ?? undefined;
  let t2;
  if ($[0] !== lensH || $[1] !== lensW || $[2] !== t1) {
    t2 = <feImage result="map" preserveAspectRatio="none" x="0" y="0" width={lensW} height={lensH} href={t1} />;
    $[0] = lensH;
    $[1] = lensW;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== dispRId) {
    t3 = <feDisplacementMap in="SourceGraphic" in2="map" id={dispRId} xChannelSelector="R" yChannelSelector="G" scale="0" result="dr" />;
    $[4] = dispRId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <feColorMatrix in="dr" type="matrix" values="1 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0" result="r" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== dispGId) {
    t5 = <feDisplacementMap in="SourceGraphic" in2="map" id={dispGId} xChannelSelector="R" yChannelSelector="G" scale="0" result="dg" />;
    $[7] = dispGId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <feColorMatrix in="dg" type="matrix" values="0 0 0 0 0  0 1 0 0 0  0 0 0 0 0  0 0 0 1 0" result="g" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== dispBId) {
    t7 = <feDisplacementMap in="SourceGraphic" in2="map" id={dispBId} xChannelSelector="R" yChannelSelector="G" scale="0" result="db" />;
    $[10] = dispBId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <feColorMatrix in="db" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 1 0 0  0 0 0 1 0" result="b" />;
    t9 = <feComposite in="r" in2="g" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="rg" />;
    t10 = <feComposite in="rg" in2="b" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="rgb" />;
    t11 = <feGaussianBlur in="rgb" stdDeviation="0.12" />;
    $[12] = t10;
    $[13] = t11;
    $[14] = t8;
    $[15] = t9;
  } else {
    t10 = $[12];
    t11 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t12;
  if ($[16] !== filterId || $[17] !== t2 || $[18] !== t3 || $[19] !== t5 || $[20] !== t7) {
    t12 = <svg width="0" height="0" className="absolute" aria-hidden="true"><defs><filter id={filterId} x="-100%" y="-100%" width="300%" height="300%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</filter></defs></svg>;
    $[16] = filterId;
    $[17] = t2;
    $[18] = t3;
    $[19] = t5;
    $[20] = t7;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}